export const CATEGORIES = [
  "Protein", "Vegetable", "Fruit", "Carb", "Dairy/Alternative",
  "Beverage", "Supplement", "Condiment", "Snack", "Other",
];

export const UNITS = ["oz", "lb", "grams", "ml", "fl oz", "count", "servings"];

export const MEAL_SLOTS = [
  "Breakfast", "Mid-Morning", "Lunch", "Snack", "Dinner", "Drinks", "Supplements",
];

export const CATEGORY_COLORS = {
  Protein: "bg-rose-100 text-rose-700",
  Vegetable: "bg-emerald-100 text-emerald-700",
  Fruit: "bg-pink-100 text-pink-700",
  Carb: "bg-amber-100 text-amber-700",
  "Dairy/Alternative": "bg-sky-100 text-sky-700",
  Beverage: "bg-cyan-100 text-cyan-700",
  Supplement: "bg-violet-100 text-violet-700",
  Condiment: "bg-lime-100 text-lime-700",
  Snack: "bg-orange-100 text-orange-700",
  Other: "bg-slate-100 text-slate-700",
};
